<template>
  <div class="grid-view__cell grid-field-long-text__cell">
    <div class="grid-field-long-text">
      <SearchHighlightedText :text="value" :search-term="searchTerm" />
    </div>
  </div>
</template>

<script>
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldLongText',
  components: { SearchHighlightedText },
  props: {
    value: {
      type: String,
      default: '',
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
